/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Infrastructure_LiveInputs */

const en_b2b_infrastructure_live = /** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B2B Infrastructure Live`)
};

const es_b2b_infrastructure_live = /** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infraestructura B2B Activa`)
};

const fr_b2b_infrastructure_live = /** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastructure B2B en ligne`)
};

const de_b2b_infrastructure_live = /** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B2B-Infrastruktur Live`)
};

const id_b2b_infrastructure_live = /** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infrastruktur B2B Live`)
};

/** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */
const ja_b2b_infrastructure_live = en_b2b_infrastructure_live;

/** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */
const zh_b2b_infrastructure_live = en_b2b_infrastructure_live;

/** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */
const ar_b2b_infrastructure_live = en_b2b_infrastructure_live;

/** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */
const it_b2b_infrastructure_live = en_b2b_infrastructure_live;

/** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */
const ru_b2b_infrastructure_live = en_b2b_infrastructure_live;

/** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */
const pt_b2b_infrastructure_live = en_b2b_infrastructure_live;

/** @type {(inputs: B2b_Infrastructure_LiveInputs) => LocalizedString} */
const ko_b2b_infrastructure_live = en_b2b_infrastructure_live;

/**
* | output |
* | --- |
* | "B2B Infrastructure Live" |
*
* @param {B2b_Infrastructure_LiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_infrastructure_live = /** @type {((inputs?: B2b_Infrastructure_LiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Infrastructure_LiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_infrastructure_live(inputs)
	if (locale === "es") return es_b2b_infrastructure_live(inputs)
	if (locale === "fr") return fr_b2b_infrastructure_live(inputs)
	if (locale === "de") return de_b2b_infrastructure_live(inputs)
	if (locale === "ja") return ja_b2b_infrastructure_live(inputs)
	if (locale === "zh") return zh_b2b_infrastructure_live(inputs)
	if (locale === "ar") return ar_b2b_infrastructure_live(inputs)
	if (locale === "id") return id_b2b_infrastructure_live(inputs)
	if (locale === "it") return it_b2b_infrastructure_live(inputs)
	if (locale === "ru") return ru_b2b_infrastructure_live(inputs)
	if (locale === "pt") return pt_b2b_infrastructure_live(inputs)
	return ko_b2b_infrastructure_live(inputs)
});